import { Column, SemanticModel } from "@pufflig/prompt-studio-types";

export interface SemanticModelStore {
  isListView: boolean;
  semanticModel: SemanticModel | null;
  dbSchema: SemanticModel | null;
  selectedTable: string | null;
  selectedTableSchema?: Column[];
  selectedTableDescription: string;
  tableData: any[];
  isLoadingPreview: boolean;
  isLoadingSchema: boolean;
}

export type Mutators = [["zustand/devtools", never], ["zustand/immer", never], ["zustand/persist", any]];

export const DEFAULT_STATE: SemanticModelStore = {
  isListView: true,
  semanticModel: null,
  dbSchema: null,
  selectedTable: null,
  selectedTableSchema: undefined,
  selectedTableDescription: "",
  tableData: [],
  isLoadingPreview: false,
  isLoadingSchema: false,
};
